<div *ngIf="agentData$ | async as agentData" class="branding">
  <div class="block agent">
    <app-user-info-block [data]="agentData.data"></app-user-info-block>
    <app-contact-info-block [data]="agentData.data"></app-contact-info-block>
    <app-connect-with-me-block [data]="agentData.data"></app-connect-with-me-block>
  </div>
</div>
